





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChangedHistoryModel } from '@/models/changed-history';
import { DATA } from '@/config/data';

@Component
export default class StatusHistory extends Vue {
  @Prop({default: []})
  private historiesChanged!: ChangedHistoryModel[];
  private statusColor(content) {
      const color = '#49494a';
      if (content.includes('đã HOÀN THÀNH') || content === 'HOÀN THÀNH' || content === 'ĐÃ HOÀN THÀNH') {
          const status = DATA.orderStatus.find(x => x.value === 10);
          return status ? status.color : color;
      }
      if (content.includes('thành ĐÃ THANH TOÁN') || content.includes('đã THANH TOÁN') || content === 'ĐÃ THANH TOÁN') {
          const status = DATA.orderStatus.find(x => x.value === 9);
          return status ? status.color : color;
      }
      if (content.includes('thành ĐÃ NHẬP KHO') || content === 'ĐÃ NHẬP KHO' || content === 'ĐÃ NHẬP KHO VN') {
          const status = DATA.orderStatus.find(x => x.value === 7);
          return status ? status.color : color;
      }
      if (content === 'ĐÃ NHẬP KHO TQ') {
          const status = DATA.orderStatus.find(x => x.value === 12);
          return status ? status.color : color;
      }
      if (content === 'CHỜ XUẤT KHO TQ') {
          const status = DATA.orderStatus.find(x => x.value === 14);
          return status ? status.color : color;
      }
      if (content === 'ĐÃ XUẤT KHO TQ') {
          const status = DATA.orderStatus.find(x => x.value === 15);
          return status ? status.color : color;
      }
      if (content.includes('thành ĐANG VẬN CHUYỂN') || content === 'ĐANG VẬN CHUYỂN' || content === 'SHOP ĐÃ PHÁT HÀNG') {
          const status = DATA.orderStatus.find(x => x.value === 16);
          return status ? status.color : color;
      }
      if (content.includes('thành ĐÃ MUA HÀNG') || content === 'ĐÃ MUA HÀNG') {
          const status = DATA.orderStatus.find(x => x.value === 5);
          return status ? status.color : color;
      }
      if (content.includes('ĐẶT CỌC đơn hàng thành công') || content === 'ĐẶT CỌC' || content === 'ĐÃ ĐẶT CỌC') {
          const status = DATA.orderStatus.find(x => x.value === 2);
          return status ? status.color : color;
      }
      if (content.includes('thành KHIẾU NẠI') || content === 'KHIẾU NẠI') {
          const status = DATA.orderStatus.find(x => x.value === 13);
          return status ? status.color : color;
      }
      if (content.includes('thành ĐƠN HÀNG HỦY') || content === 'ĐƠN HÀNG HỦY') {
          const status = DATA.orderStatus.find(x => x.value === 1);
          return status ? status.color : color;
      }
      if (content.includes('thành CHỜ ĐẶT CỌC') || content === 'CHỜ ĐẶT CỌC') {
          const status = DATA.orderStatus.find(x => x.value === 0);
          return status ? status.color : color;
      }
      return color;
  }
}
